import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import ColorRgbDialog1 from "../twin-widget-dialog/color-rgb-dialog-1";
import ColorTemperatureDialog1 from "../twin-widget-dialog/color-temperature-dialog-1";

const Color1Widget = ({ widget, onValueUpdate }) => {
  const [colorRgb, setColorRgb] = useState("ffffff");
  const [colorTemp, setColorTemp] = useState(2700);
  const [current, setCurrent] = useState("rgb");
  const [widgetData, setWidgetData] = useState(null);

  const [tempMinMax, setTempMinMax] = useState({ min: 2700, max: 6500 });

  useEffect(() => {
    if (!widget) return;

    setWidgetData(widget);

    if (widget.items?.$w1) {
      const colorValue = widget.items.$w1.value.toLowerCase() || "ffffff";
      setColorRgb(colorValue.replace(/^#/, ""));
    }

    if (widget.items?.$w2) {
      setTempMinMax({
        min: widget.items.$w2.min ?? 2700,
        max: widget.items.$w2.max ?? 6500,
      });
      setColorTemp(widget.items.$w2.value || 2700);
    }
    if (widget.items?.$w3) {
      setCurrent(widget.items.$w3.value || "rgb");
    }
  }, [widget]);

  const handleValueUpdate = (data, type) => {
    if (!widgetData) return;

    const updatedWidgets = {};

    if (type === "$w1") {
      updatedWidgets.$w1 = { ...widgetData.items.$w1 };
      updatedWidgets.$w3 = { ...widgetData.items.$w3 };
      updatedWidgets.$w1.value = data.replace(/^#/, "");
      updatedWidgets.$w3.value = "rgb";
      setColorTemp(null);
      setCurrent("rgb");
    } else if (type === "$w2") {
      updatedWidgets.$w2 = { ...widgetData.items.$w2 };
      updatedWidgets.$w3 = { ...widgetData.items.$w3 };
      updatedWidgets.$w2.value = data;
      updatedWidgets.$w3.value = "temperature";
      setColorRgb(null);
      setCurrent("temperature");
    }

    onValueUpdate(Object.values(updatedWidgets));
  };

  const handleRgbUpdate = (newColor) => {
    if (!newColor) return;
    setColorRgb(newColor);
    handleValueUpdate(newColor, "$w1");
  };

  const handleTempUpdate = (event, newValue) => {
    event.stopPropagation();

    const adjustedValue = Math.min(
      Math.max(newValue, tempMinMax.min),
      tempMinMax.max
    );

    setColorTemp(adjustedValue);
    handleValueUpdate(adjustedValue, "$w2");
  };

  if (!widgetData) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div>Loading...</div>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        height: "100%",
        minHeight: "fit-content",
        overflow: "hidden",
        gap: "8px",
      }}
    >
      <ColorRgbDialog1
        color={colorRgb}
        onValueUpdate={handleRgbUpdate}
        current={current}
      />

      <ColorTemperatureDialog1
        colorTemp={colorTemp}
        onColorTempChange={handleTempUpdate}
        minTemp={tempMinMax.min}
        maxTemp={tempMinMax.max}
        current={current}
      />
    </Box>
  );
};

export default Color1Widget;
